import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useJourneySelector() {
  const JourneyListData = useSelector((state) => state.Journey.list_data?.journeys) || []; // List data
  const JourneyEdit = useSelector((state) => state.Journey.edit_data?.journeyConfigs) || {}; // edit
  const TemplateData =
    useSelector((state) => state.Journey.template_data?.journeyTemplateList) || []; // Template Data

  const JourneyTemplateNameList = useSelector((state) => state.Journey.template_name_list);

  const JourneyTemplateNameListDrop = useMemo(() => {
    const list = JourneyTemplateNameList || [];
    return list?.map((item) => ({
      value: item?.templateId,
      label: item?.templateName
    }));
  }, [JourneyTemplateNameList]);

  return { JourneyListData, JourneyEdit, TemplateData, JourneyTemplateNameListDrop };
}
